<template>
  <div class="culture bold">
    <div>你以为这个页面会有东西？</div>
    <div>你错了</div>
    <div>设计没给我设计稿，怎么会有东西？</div>
  </div>
</template>
<script>
export default {
  name:'Culture',
  componentName:'Culture'
}
</script>
<style lang="scss" scoped>
  @import "../common/common.scss"; 
  @import "../common/theme.scss";
  .culture {
    background-color: $themeColor;
    height: 100%;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 20px;
    div {
      + div {
        margin-top: 20px;
      }
      &:last-child {
        color: yellow;
      }
    }
  }
</style>